import React, { useState, useEffect } from 'react';

const TimeHeader = () => {
  const [time, setTime] = useState("");
  const [date, setDate] = useState("");

  useEffect(() => {
    const updateTime = () => {
      const sriLankaTime = new Date().toLocaleString("en-US", { timeZone: "Asia/Colombo" });
      const currentDate = new Date(sriLankaTime);
      setTime(currentDate.toLocaleTimeString());
      setDate(currentDate.toLocaleDateString());
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className='flex justify-between items-center pl-3 pr-3 py-1 text-white' style={{ backgroundColor: "#252525", width: '100%' }}>
      <div><small className='font-bold'>Sewanagala Ayurvedaya</small></div>
      <div><small className='font-medium'>{time}</small></div>
      <div><small className='font-medium'>{date}</small></div>
    </div>
  )
}

export default TimeHeader;
